import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type AppMessageType =
  | 'success'
  | 'error'
  | 'warning'
  | 'info'
  | 'confirm';

interface AppMessageState {
  visible: boolean;
  type: AppMessageType;
  title: string;
  message: string;
  confirmActionKey: string | null;
}

interface ShowMessagePayload {
  type?: AppMessageType;
  title: string;
  message: string;
}

interface ShowConfirmPayload {
  title: string;
  message: string;
  confirmActionKey: string;
}

const initialState: AppMessageState = {
  visible: false,
  type: 'info',
  title: '',
  message: '',
  confirmActionKey: null,
};

const appMessageSlice = createSlice({
  name: 'appMessage',
  initialState,
  reducers: {
    showMessage: (state, action: PayloadAction<ShowMessagePayload>) => {
      state.visible = true;
      state.type = action.payload.type || 'info';
      state.title = action.payload.title;
      state.message = action.payload.message;
      state.confirmActionKey = null;
    },
    showConfirmMessage: (state, action: PayloadAction<ShowConfirmPayload>) => {
      state.visible = true;
      state.type = 'confirm';
      state.title = action.payload.title;
      state.message = action.payload.message;
      state.confirmActionKey = action.payload.confirmActionKey;
    },
    hideMessage: state => {
      state.visible = false;
      state.confirmActionKey = null;
    },
  },
});

export const { showMessage, showConfirmMessage, hideMessage } =
  appMessageSlice.actions;

export default appMessageSlice.reducer;
